import React, { useState } from "react";
import { AiOutlineLike } from "react-icons/ai";

import { Link } from "react-router-dom";
import "./product.css";
import { AiTwotoneStar } from "react-icons/ai";

const ProgressBar = (props) => {
  return (
    <>
      <a
        href="#quistion"
        className="d-flex align-center mb-2 rating-progress-bar"
      >
        <div className="d-flex align-center mr-2 rate-number-star">
          <span className="revProgress-number">{props.number}</span>
          <AiTwotoneStar className="ml-auto single-review-star rating-star-isHover" />
        </div>
        <div class="progress">
          <div class="bar bar-is-hover"></div>
        </div>
        <div className="all-reviews-number rate-number-star">
          <span className="revProgress-number">{props.number}</span>
        </div>
      </a>
    </>
  );
};

const Rating = () => {
  return (
    <>
      <div className="wrapper-90">
        <div className="reviews-showCase d-flex  bg-white align-center">
          <div className="ratingShowCase-card">
            <span className="d-block rating-number">4.3</span>
            <img src="../assets/images/review-star.svg" alt="" />
            <p>434 Reviews</p>
          </div>
          <div className="ratingShowCase-card">
            <ProgressBar number="5" />
            <ProgressBar number="4" />
            <ProgressBar number="3" />
            <ProgressBar number="2" />
            <ProgressBar number="1" />
          </div>
        </div>
      </div>
    </>
  );
};

const ReviewRow = () => {
  const [helpFul, setHelpFul] = useState(true);
  const [helpFullNumber, setHelpFullNumber] = useState(1);
  const defaultHelpNum = 1;
  const likedReview = () => {
    helpFul
      ? setHelpFullNumber(helpFullNumber + 1)
      : setHelpFullNumber(defaultHelpNum);
    setHelpFul(!helpFul);
  };
  return (
    <>
      <div className="bg-white reviews-container mt-5 px-4">
        <div className="rating-section-row">
          <div>
            <h4 className="reviewer-name">Reviewer Name</h4>
            <small className="reviewer-location text-grey">
              Reviewer State
            </small>
            <span className="verify-text d-block">VERIFIED BUYER </span>
            <div className="d-flex">
              <span className="rater-images">
                <img
                  src="https://sundialinsider.s3.us-east-2.amazonaws.com/500cart-sidebar.jpg"
                  width="100%"
                  alt="Loading..."
                />
              </span>
              <span className="rater-images">
                <img
                  src="https://sundialinsider.s3.us-east-2.amazonaws.com/500cart-sidebar.jpg"
                  width="100%"
                  alt="Loading..."
                />
              </span>
              <span className="rater-images">
                <img
                  src="https://sundialinsider.s3.us-east-2.amazonaws.com/500cart-sidebar.jpg"
                  width="100%"
                  alt="Loading..."
                />
              </span>
            </div>
          </div>
          <div>
            <h4 className="reviewer-name">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint
              deleniti accusamus minus possimus. Sed iste dolore perspiciatis,
              praesentium doloribus quo eligendi sunt voluptate, doloremque
              voluptates, consequuntur autem a est similique necessitatibus eum?
              Rem ratione vero, illum maxime, nihil tenetur unde quidem neque,
              esse odio nostrum at perferendis veritatis laborum explicabo
              molestias soluta? Architecto ipsa deserunt illo? Qui eius ipsum
              accusantium ut unde itaque esse molestias.
            </h4>
          </div>
          <div>
            <div className="mt-2 helpFull-btn">
              <label
                onClick={likedReview}
                className={
                  helpFul
                    ? "like-lable"
                    : "like-lable bg-default default-hover review-helpFull"
                }
              >
                <div className="d-flex justify-between align-center">
                  <AiOutlineLike className="helpFull-linke" />
                  <span>Helpful</span>
                  <span>{helpFullNumber}</span>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { Rating, ReviewRow };
